import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row mb-20" }
const _hoisted_2 = { class: "col span-12 target-groups" }
const _hoisted_3 = { class: "row mb-10" }
const _hoisted_4 = { class: "col span-6" }
const _hoisted_5 = { class: "col span-3" }
const _hoisted_6 = {
  key: 1,
  class: "col span-6"
}
const _hoisted_7 = {
  key: 2,
  class: "col span-6"
}
const _hoisted_8 = {
  key: 3,
  class: "col span-6"
}
const _hoisted_9 = {
  class: "col span-3",
  "data-testid": "clusterrepo-refresh-interval"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col span-6" }
const _hoisted_13 = { class: "mb-10 mt-20" }
const _hoisted_14 = { class: "row mb-40 mt-10" }
const _hoisted_15 = {
  class: "col span-4",
  "data-testid": "clusterrepo-oci-min-wait-input"
}
const _hoisted_16 = {
  class: "col span-4",
  "data-testid": "clusterrepo-oci-max-wait-input"
}
const _hoisted_17 = { class: "col span-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RcItemCard = _resolveComponent("RcItemCard")!
  const _component_NameNsDescription = _resolveComponent("NameNsDescription")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_LabeledInput = _resolveComponent("LabeledInput")!
  const _component_UnitInput = _resolveComponent("UnitInput")!
  const _component_SelectOrCreateAuthSecret = _resolveComponent("SelectOrCreateAuthSecret")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Labels = _resolveComponent("Labels")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.t('catalog.repo.target.label')), 1),
    _cache[27] || (_cache[27] = _createTextVNode()),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.clusterRepoTargets, (card) => {
          return (_openBlock(), _createBlock(_component_RcItemCard, {
            id: card.id,
            key: card.id,
            header: card.header,
            image: card.image,
            content: card.content,
            selected: $data.clusterRepoType === card.id,
            clickable: true,
            disabled: $data.isView,
            variant: "small",
            onCardClick: ($event: any) => ($options.onTargetChange(card.id))
          }, null, 8, ["id", "header", "image", "content", "selected", "disabled", "onCardClick"]))
        }), 128))
      ])
    ]),
    _cache[28] || (_cache[28] = _createTextVNode()),
    (_openBlock(), _createBlock(_component_NameNsDescription, {
      key: $data.clusterRepoType,
      value: _ctx.value,
      mode: _ctx.mode,
      namespaced: _ctx.isNamespaced,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event)))
    }, null, 8, ["value", "mode", "namespaced"])),
    _cache[29] || (_cache[29] = _createTextVNode()),
    ($data.clusterRepoType === $data.CLUSTER_REPO_TYPES.OCI_URL)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Banner, {
            "label-key": "catalog.repo.oci.warning",
            color: "warning"
          }),
          _cache[18] || (_cache[18] = _createTextVNode()),
          _createVNode(_component_Banner, {
            label: _ctx.t('catalog.repo.oci.info', null, true),
            color: "info"
          }, null, 8, ["label"])
        ], 64))
      : _createCommentVNode("", true),
    _cache[30] || (_cache[30] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      ($data.clusterRepoType === $data.CLUSTER_REPO_TYPES.GIT_REPO)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_LabeledInput, {
                value: _ctx.value.spec.gitRepo,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.spec.gitRepo) = $event)),
                valueModifiers: { trim: true },
                required: true,
                label: _ctx.t('catalog.repo.gitRepo.label'),
                placeholder: _ctx.t('catalog.repo.gitRepo.placeholder', null, true),
                mode: _ctx.mode,
                "data-testid": "clusterrepo-git-repo-input"
              }, null, 8, ["value", "label", "placeholder", "mode"])
            ]),
            _cache[19] || (_cache[19] = _createTextVNode()),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_LabeledInput, {
                value: _ctx.value.spec.gitBranch,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.spec.gitBranch) = $event)),
                valueModifiers: { trim: true },
                "sub-label": !_ctx.value.spec.gitBranch ? _ctx.t('catalog.repo.gitBranch.defaultMessage', null, true) : undefined,
                label: _ctx.t('catalog.repo.gitBranch.label'),
                placeholder: _ctx.t('catalog.repo.gitBranch.placeholder', null, true),
                mode: _ctx.mode,
                "data-testid": "clusterrepo-git-branch-input"
              }, null, 8, ["value", "sub-label", "label", "placeholder", "mode"])
            ])
          ], 64))
        : ($data.clusterRepoType === $data.CLUSTER_REPO_TYPES.OCI_URL)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_LabeledInput, {
                value: _ctx.value.spec.url,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.spec.url) = $event)),
                valueModifiers: { trim: true },
                required: true,
                label: _ctx.t('catalog.repo.oci.urlLabel'),
                placeholder: _ctx.t('catalog.repo.oci.placeholder', null, true),
                mode: _ctx.mode,
                "data-testid": "clusterrepo-oci-url-input"
              }, null, 8, ["value", "label", "placeholder", "mode"])
            ]))
          : ($data.clusterRepoType === $data.CLUSTER_REPO_TYPES.SUSE_APP_COLLECTION)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_LabeledInput, {
                  value: _ctx.value.spec.url,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value.spec.url) = $event)),
                  valueModifiers: { trim: true },
                  required: true,
                  label: _ctx.t('catalog.repo.oci.urlLabel'),
                  placeholder: _ctx.t('catalog.repo.oci.placeholder', null, true),
                  mode: _ctx.mode,
                  "data-testid": "clusterrepo-oci-url-input",
                  disabled: true
                }, null, 8, ["value", "label", "placeholder", "mode"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_LabeledInput, {
                  value: _ctx.value.spec.url,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.spec.url) = $event)),
                  valueModifiers: { trim: true },
                  required: true,
                  label: _ctx.t('catalog.repo.url.label'),
                  placeholder: _ctx.t('catalog.repo.url.placeholder', null, true),
                  mode: _ctx.mode,
                  "data-testid": "clusterrepo-helm-url-input"
                }, null, 8, ["value", "label", "placeholder", "mode"])
              ])),
      _cache[20] || (_cache[20] = _createTextVNode()),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_UnitInput, {
          value: _ctx.value.spec.refreshInterval,
          "onUpdate:value": [
            _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value.spec.refreshInterval) = $event)),
            _cache[7] || (_cache[7] = ($event: any) => ($options.updateRefreshInterval($event)))
          ],
          valueModifiers: { trim: true },
          label: _ctx.t('catalog.repo.refreshInterval.label'),
          mode: _ctx.mode,
          min: "0",
          suffix: _ctx.t('unit.hour', { count: _ctx.value.spec.refreshInterval }),
          placeholder: _ctx.t('catalog.repo.refreshInterval.placeholder', { hours: $data.clusterRepoType === $data.CLUSTER_REPO_TYPES.OCI_URL ? 24 : 6 })
        }, null, 8, ["value", "label", "mode", "suffix", "placeholder"])
      ])
    ]),
    _cache[31] || (_cache[31] = _createTextVNode()),
    _createVNode(_component_SelectOrCreateAuthSecret, {
      value: _ctx.value.spec.clientSecret,
      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.value.spec.clientSecret) = $event)),
      mode: _ctx.mode,
      "data-testid": "clusterrepo-auth-secret",
      "register-before-hook": _ctx.registerBeforeHook,
      namespace: $options.secretNamespace,
      "limit-to-namespace": false,
      "in-store": $options.inStore,
      "allow-ssh": $data.clusterRepoType !== $data.CLUSTER_REPO_TYPES.OCI_URL,
      "pre-select": $data.clusterRepoType === $data.CLUSTER_REPO_TYPES.SUSE_APP_COLLECTION ? { selected: $data.AUTH_TYPE._BASIC } : null,
      "allow-none": $data.clusterRepoType !== $data.CLUSTER_REPO_TYPES.SUSE_APP_COLLECTION,
      "generate-name": $data.clusterRepoType === $data.CLUSTER_REPO_TYPES.SUSE_APP_COLLECTION ? $data.CLUSTER_REPO_APPCO_AUTH_GENERATE_NAME : $data.CLUSTER_REPO_AUTH_GENERATE_NAME,
      "cache-secrets": true,
      "fixed-http-basic-auth": $data.clusterRepoType === $data.CLUSTER_REPO_TYPES.SUSE_APP_COLLECTION,
      "filter-basic-auth": $data.CLUSTER_REPO_APPCO_AUTH_GENERATE_NAME
    }, null, 8, ["value", "mode", "register-before-hook", "namespace", "in-store", "allow-ssh", "pre-select", "allow-none", "generate-name", "fixed-http-basic-auth", "filter-basic-auth"]),
    _cache[32] || (_cache[32] = _createTextVNode()),
    ($data.clusterRepoType === $data.CLUSTER_REPO_TYPES.OCI_URL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_LabeledInput, {
                value: _ctx.value.spec.caBundle,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.value.spec.caBundle) = $event)),
                class: "mt-20",
                type: "multiline",
                label: "CA Cert Bundle",
                mode: _ctx.mode,
                "data-testid": "clusterrepo-oci-cabundle-input"
              }, null, 8, ["value", "mode"]),
              _cache[21] || (_cache[21] = _createTextVNode()),
              _createVNode(_component_Checkbox, {
                value: _ctx.value.spec.insecureSkipTLSVerify,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.value.spec.insecureSkipTLSVerify) = $event)),
                class: "mt-10",
                mode: _ctx.mode,
                label: _ctx.t('catalog.repo.oci.skipTlsVerifications'),
                "data-testid": "clusterrepo-oci-skip-tls-checkbox"
              }, null, 8, ["value", "mode", "label"]),
              _cache[22] || (_cache[22] = _createTextVNode()),
              _createVNode(_component_Checkbox, {
                value: _ctx.value.spec.insecurePlainHttp,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.value.spec.insecurePlainHttp) = $event)),
                class: "mt-10",
                mode: _ctx.mode,
                label: _ctx.t('catalog.repo.oci.insecurePlainHttp'),
                "data-testid": "clusterrepo-oci-insecure-plain-http"
              }, null, 8, ["value", "mode", "label"])
            ])
          ]),
          _cache[25] || (_cache[25] = _createTextVNode()),
          _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.t('catalog.repo.oci.exponentialBackOff.label')), 1),
          _cache[26] || (_cache[26] = _createTextVNode()),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_UnitInput, {
                value: $data.ociMinWait,
                "onUpdate:value": [
                  _cache[12] || (_cache[12] = ($event: any) => (($data.ociMinWait) = $event)),
                  _cache[13] || (_cache[13] = ($event: any) => ($options.updateExponentialBackOffValues('minWait', $event)))
                ],
                valueModifiers: { trim: true },
                label: _ctx.t('catalog.repo.oci.exponentialBackOff.minWait.label'),
                placeholder: _ctx.t('catalog.repo.oci.exponentialBackOff.minWait.placeholder'),
                mode: _ctx.mode,
                min: "1",
                suffix: _ctx.t('suffix.seconds', { count: $data.ociMinWait })
              }, null, 8, ["value", "label", "placeholder", "mode", "suffix"])
            ]),
            _cache[23] || (_cache[23] = _createTextVNode()),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_UnitInput, {
                value: $data.ociMaxWait,
                "onUpdate:value": [
                  _cache[14] || (_cache[14] = ($event: any) => (($data.ociMaxWait) = $event)),
                  _cache[15] || (_cache[15] = ($event: any) => ($options.updateExponentialBackOffValues('maxWait', $event)))
                ],
                valueModifiers: { trim: true },
                label: _ctx.t('catalog.repo.oci.exponentialBackOff.maxWait.label'),
                placeholder: _ctx.t('catalog.repo.oci.exponentialBackOff.maxWait.placeholder'),
                mode: _ctx.mode,
                min: "1",
                suffix: _ctx.t('suffix.seconds', { count: $data.ociMaxWait })
              }, null, 8, ["value", "label", "placeholder", "mode", "suffix"])
            ]),
            _cache[24] || (_cache[24] = _createTextVNode()),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_LabeledInput, {
                value: $data.ociMaxRetries,
                "onUpdate:value": [
                  _cache[16] || (_cache[16] = ($event: any) => (($data.ociMaxRetries) = $event)),
                  _cache[17] || (_cache[17] = ($event: any) => ($options.updateExponentialBackOffValues('maxRetries', $event)))
                ],
                valueModifiers: { trim: true },
                label: _ctx.t('catalog.repo.oci.exponentialBackOff.maxRetries.label'),
                placeholder: _ctx.t('catalog.repo.oci.exponentialBackOff.maxRetries.placeholder'),
                mode: _ctx.mode,
                type: "number",
                min: "0",
                "data-testid": "clusterrepo-oci-max-retries-input"
              }, null, 8, ["value", "label", "placeholder", "mode"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[33] || (_cache[33] = _createTextVNode()),
    _createVNode(_component_Labels, {
      "default-section-class": "mt-20",
      value: _ctx.value,
      mode: _ctx.mode,
      "display-side-by-side": false
    }, null, 8, ["value", "mode"]),
    _cache[34] || (_cache[34] = _createTextVNode()),
    _createVNode(_component_Footer, {
      "data-testid": "clusterrepo-footer",
      mode: _ctx.mode,
      errors: _ctx.errors,
      onSave: _ctx.save,
      onDone: _ctx.done
    }, null, 8, ["mode", "errors", "onSave", "onDone"])
  ]))
}